var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteEmailInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B4C3D0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "email",
    className: "st0",
    d: "M21.6,7.4L12,13.1L2.4,7.4V5.1l9.6,5.7l9.6-5.7V7.4L21.6,7.4z M21.6,2.9H2.4C1,2.9,0,3.9,0,5.1v13.7 c0,1.3,1,2.3,2.4,2.3h19.2c1.4,0,2.4-1,2.4-2.3V5.1C24,3.9,23,2.9,21.6,2.9L21.6,2.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteEmailInactive);
export default __webpack_public_path__ + "static/media/invite_email_inactive.8ce9475767a4a12bdece947c38e2b837.svg";
export { ForwardRef as ReactComponent };